import { UWebsocketsServerConnection } from "realms-engine-network-client";
import { MMOConfig } from "../../configs";
import { getEnvironment } from "realms-react-utils";
import { Environment } from "realms-utils";

/**
 * Creates a connection to the server
 */
export const createMMOServerConnection = () => {
  return new UWebsocketsServerConnection(MMOConfig.serverUrl, {
    ssl: getEnvironment() === Environment.Production,
  });
  // return new SocketIOServerConnection(MMOConfig.serverUrl);
};
